// extracted by mini-css-extract-plugin
module.exports = {"fixedHeader":"src-layout-HeaderView-module__fixedHeader--3OLBP"};